import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import documentUploadService from "../../components/Services/documentUpload.service";
import { toastProperties } from "../../commons/Toast/Toaster";

const CustomConfirmBox = ({
  title,
  message,
  open,
  handleClose,
  handleCloseNo,
  rejectConnection,
  showUploadAgreement,
  handleSuccess,
  handleClosePopup,
  loading,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [isSelectionValid, setIsSelectionValid] = useState(true);
  const [agreement, setAgreement] = useState(null);

  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );
  const [localLoading, setLocalLoading] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    setIsSelectionValid(true);
  };

  const handleReject = () => {
    if (rejectConnection && selectedValue === null) {
      setIsSelectionValid(false);
    } else if (showUploadAgreement && agreement === null) {
      setIsSelectionValid(false);
    } else {
      handleClose(agreement?.id);
      setIsSelectionValid(true);
    }
  };
  localStorage.setItem("RejectedReason", selectedValue);
  const handleProofOfPayment = (e, type) => {
    const fun = async (e) => {
      const fileList = e?.target?.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        let extension = file.name.split(".").pop();
        let fileSize = file.size / 1024 / 1024;
        let extList = ["pdf"];
        if (fileSize < 10) {
          if (extList.includes(extension)) {
            let formData = new FormData();
            formData.append("file", file);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            let data = (
              await documentUploadService.documentUpload(type, formData, config)
            )?.data;
            if (data?.data) {
              setAgreement(data?.data || "");
              setIsSelectionValid(true);
              toast.success("Uploaded Successfully", toastProperties);
            } else {
              toast.error("Failed to upload File", toastProperties);
              // setFieldValue(key, "");
            }
          } else {
            // setFieldValue(key, "");
            toast.error("Only Pdf formats can be uploaded", toastProperties);
          }
        } else {
          toast.error("File Size Cannot Exceed 10mb", toastProperties);
          //  setFieldValue(key, "");
        }
      } else {
        // setFieldValue(key, "");
      }
    };
    fun(e);
  };

  useEffect(() => {
    if (!open) setLocalLoading(false);
  }, [open]);
  return (
    <>
      {localLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress size={40} style={{ color: "#f1935c" }} />
        </div>
      )}

      <Dialog fullWidth open={open}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{title}</span>
            <button
              onClick={handleClosePopup || handleCloseNo}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                padding: 0,
                margin: 0,
              }}
              aria-label="close"
            >
              ✕
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {!rejectConnection && <h6>{message}</h6>}
          </DialogContentText>

          {rejectConnection && (
            <div>
              <h6>Please Select Your reason for rejection</h6>
              <RadioGroup value={selectedValue} onChange={handleRadioChange}>
                <FormControlLabel
                  value="PRICE"
                  control={<Radio />}
                  label="Price"
                />
                <FormControlLabel
                  value="QUANTITY"
                  control={<Radio />}
                  label="Quantity"
                />
                <FormControlLabel
                  value="DATE_TIME_BLOCK"
                  control={<Radio />}
                  label="Date/Time Block"
                />
                <FormControlLabel
                  value="OTHER"
                  control={<Radio />}
                  label="Other"
                />
              </RadioGroup>
              {!isSelectionValid && (
                <p style={{ color: "red" }}>
                  Please select a reason for rejection.
                </p>
              )}
            </div>
          )}
          {showUploadAgreement && (
            <>
              <div className="file-input-wrapper">
                <input
                  type="file"
                  id="file-input2"
                  className="file-input"
                  onChange={(e) => handleProofOfPayment(e, "AGREEMENT")}
                />
                <span>{agreement?.fileName || "Upload Agreement*"}</span>
                <label htmlFor="file-input2" className="file-input-label">
                  Upload
                </label>
              </div>
              {!isSelectionValid && (
                <p style={{ color: "red" }}>
                  Please Upload the Agreement and then click on Yes.
                </p>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions className="mb-2 me-4">
          {title === "Bilateral Connect" ? (
            <>
              {/* <button
                className="btn btn-approve"
                disabled={isButtonEnabled || localLoading}
                onClick={async () => {
                  setLocalLoading(true);
                  try {
                    const success = await handleSuccess();
                    if (success) {
                      window.location.reload();
                    }
                  } finally {
                    setLocalLoading(false);
                  }
                }}
                style={{ position: "relative", minWidth: "90px" }}
              >
                {localLoading && (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "#f1935c",
                      position: "absolute",
                      left: "45%",
                      top: "30%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 2,
                    }}
                  />
                )}
                <span
                  style={{
                    opacity: localLoading ? 0 : 1,
                    transition: "opacity 0.2s",
                  }}
                >
                  Accept
                </span>
              </button> */}
              <button
                className="btn btn-approve"
                disabled={isButtonEnabled || localLoading}
                onClick={async () => {
                  setLocalLoading(true);
                  try {
                    const success = await handleSuccess();
                    if (success) {
                      window.location.reload();
                    }
                  } finally {
                    setLocalLoading(false);
                  }
                }}
                style={{ position: "relative", minWidth: "90px" }}
              >
                Accept
              </button>

              <button className="btn btn-withdrawal" onClick={handleClose}>
                Deny
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-approve"
                disabled={isButtonEnabled}
                onClick={
                  rejectConnection || showUploadAgreement
                    ? handleReject
                    : handleClose
                }
              >
                Accept
              </button>
              <button className="btn btn-withdrawal" onClick={handleCloseNo}>
                Deny
              </button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomConfirmBox;
